import React, { useEffect, useState } from "react";
import { Bar } from "@ant-design/plots";
import queryKeys from "common/queryKey";
import moment from "moment";
import { connect } from "react-redux";
import { getClientid, getRoleList } from "redux/selectors";
import { useFetch } from "hooks/useFetch";
import { Spin } from "antd";
import DetailsModal from "organisms/DetailsModal";

function HeadcountByLevel({ value, clientid, roleList }) {
  const [headCountByLevelData, setHeadCountByLevelData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [plotData, setPlotData] = useState("");

  const { getHeadCountByLevelData, getConfiguration } = queryKeys;

  const payload = {
    method: "headCountByLevel",
    parameters: {
      startDate: value?.date ? moment(value?.date).format("YYYY-MM-DD") : "",
      endDate: value?.end_date
        ? moment(value?.end_date).format("YYYY-MM-DD")
        : "",
      managingOffice: value?.managingoffice || [],
      competencyQC: value?.competencyQC || [],
      officesupervisor: value?.officesupervisor || "",
    },
  };

  const payloadString = JSON.stringify(payload);
  const { key, url } = getHeadCountByLevelData(clientid, payloadString);

  const { data, isLoading, refetch } = useFetch(
    key,
    url,
    {
      enabled: !!clientid,
    },
    payload
  );

  const { key: configurationKey, url: configurationUrl } = getConfiguration();
  const { data: configurationData, isLoading: isConfigurationLoading } = useFetch(
    configurationKey,
    configurationUrl,
    {
      enabled: !!clientid,
    }
  );

  useEffect(() => {
    const dataList = data?.response?.headCountByLevel;
    if (Array.isArray(dataList)) {
      setHeadCountByLevelData(dataList);
    } else {
      setHeadCountByLevelData([]);
    }
  }, [data]);

  const Gender = ["Male", "Female", "They / Them"];
  const gradeConfigurations = configurationData?.response?.items?.filter(
    (item) => item.configurationName === "chargeout" && item.jobgradecode
  );
  const grades = gradeConfigurations && [
    ...new Map(
      gradeConfigurations.map((item) => [item.jobgradecode, item])
    ).values(),
  ].sort((first, second) =>
    String(first.jobgradecode).localeCompare(String(second.jobgradecode))
  );

  const countsByGradeAndGender = headCountByLevelData.reduce(
    (counts, person) => {
      const gender =
        person.gender === "male"
          ? "Male"
          : person.gender === "female"
          ? "Female"
          : "They / Them";
      const countKey = `${person.grade}-${gender}`;
      counts[countKey] = (counts[countKey] || 0) + 1;
      return counts;
    },
    {}
  );

  const updatedData = (grades || []).flatMap(({ jobgradecode }) =>
    Gender.map((gender) => ({
      xValue: jobgradecode,
      listItem: [jobgradecode],
      gender,
      Count: countsByGradeAndGender[`${jobgradecode}-${gender}`] || 0,
    }))
  );

  const plotClick = () => {
    if(plotData?.data?.data){
    const gradeList = plotData?.data?.data?.listItem;
    const filterData = data?.response?.headCountByLevel?.filter(
      (item) =>
        gradeList.includes(item?.grade) &&
        ((plotData.data.data.gender === "Male" && item.gender === "male") ||
          (plotData.data.data.gender === "Female" &&
            item.gender === "female") ||
          (plotData.data.data.gender === "They / Them" &&
            item.gender !== "male" &&
            item.gender !== "female"))
    );
    setTableData(filterData);
    setIsModalVisible(true);
  }
  };

  useEffect(() => {
    if (plotData !== "") {
      plotClick();
    }
  }, [plotData]);

  const config = {
    data: updatedData,
    isGroup: true,
    xField: "Count",
    yField: "xValue",
    seriesField: "gender",
    colorField: "gender",
    groupField: "gender",
    color: ["#9CD3FA", "#FAC2F8", "#A39BFF"],
    animation: false,
    label: false,
    onReady: (plot) => {
      plot.on("plot:click", (evt) => {
        setPlotData(evt);
      });
    },

    label: {
      layout: [
        { type: "interval-adjust-position" },
        { type: "interval-hide-overlap" },
        { type: "adjust-color" },
      ],
    },
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: true,
      },
      grid: {
        line: {
          style: {
            opacity: 0,
          },
        },
      },
    },
    yAxis: {
      title: {
        text: "Head Count",
        style: {
          fontSize: 12,
          fontWeight: 500,
        },
      },
      grid: {
        line: {
          style: {
            opacity: 0,
          },
        },
      },
    },
  };

  return (
    <>
      <h6 className="mt-2">Headcount by Level:</h6>
      <Spin spinning={isLoading || isConfigurationLoading}>
        <div className="box-container">
          <Bar {...config} />
        </div>
      </Spin>
      <DetailsModal
        isopen={isModalVisible}
        isCancel={() => setIsModalVisible(false)}
        tabledata={tableData}
      />
    </>
  );
}


const mapStateToProps = (state) => ({
  clientid: getClientid(state),
  roleList: getRoleList(state),
});

export default connect(mapStateToProps, null)(HeadcountByLevel);
